import {dbitem}  from './dbItem'
import teras from './teras'

var moment = require('moment');
moment.locale('it');

class abs extends dbitem{
    constructor (args) {
        super()
        this.mysql.table = 'abstract'
        this.teras = teras
        this.urlPreview = "#"
        this.lineeguida = false
        this.inviato = false
        return this
    }


    saveAutori(){
      return new Promise((resolve, reject) => {
        var autori = []
        var num = 0
        for ( const autore of JSON.parse(JSON.stringify(this.teras.autori))){
          autore.primo = (autore.id == this.row.pa) ? 1 : 0
          //delete autore.id
          autore.abstract = this.row.id
          autore.evento = this.row.evento
          console.log(typeof autore.affiliazione)
          if(typeof autore.affiliazione == 'object')
            autore.affiliazione = autore.affiliazione.join()
          autore.numero = num
          autore.id = parseInt(this.row.id)*1000+num
          if(autore.primo==1)
            this.row.pa = autore.numero
          num++        
          autori.push(autore)
        }
        console.log(autori)
        this.axios.query('doQuery','DELETE FROM autore WHERE abstract=→abstract AND evento=→evento',{evento:this.row.evento,abstract:this.row.id}).then((data) => {
          this.axios.insertRows(autori,'autore').then((data) => {
            this.axios.query('fetchAll','SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:this.teras.evento.id,abstract:this.row.id},this.teras,'autori')
            this.axios.query('fetchOne','SELECT id FROM autore WHERE numero=→numero AND abstract=→abstract ',{numero:this.row.pa,abstract:this.row.id},this.row,'pa').then((data) => {
              this.save().then((data) => {
                resolve(true)
              })
            }) //fine update pa
          })
        })
      })
    }

    saveAffiliazioni(){
      return new Promise((resolve, reject) => {
        var affiliazioni = []
        var num = 0;
        for ( const affiliazione of JSON.parse(JSON.stringify(this.teras.affiliazioni))){
          //delete affiliazione.id
          affiliazione.abstract = this.row.id
          affiliazione.evento = this.row.evento
          affiliazione.numero = num
          affiliazione.id = parseInt(this.row.id)*1000+num
          num++        
          affiliazioni.push(affiliazione)
        }
        console.log(affiliazioni)
        this.axios.query('doQuery','DELETE FROM affiliazione WHERE abstract=→abstract AND evento=→evento',{evento:this.row.evento,abstract:this.row.id}).then((data) => {
          this.axios.insertRows(affiliazioni,'affiliazione').then((data) => {
            this.axios.query('fetchAll','SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:this.row.evento,abstract:this.row.id},this.teras,'affiliazioni')          
            resolve(true)
          })
        }) 
      }) 
    }

    emailSend(){
      return new Promise((resolve, reject) => {
        //this.toSend = false
        this.row.step=1
        this.save().then((data) => {
          var args = {idAbs: this.row.id,sendto:'', lingua:'ita'}
          this.axios.post(this.axios.apiUrl+'vue/soap',{url:'http://tomcat:8080/j-bvent/services/Ws?wsdl',action:'bamsEmailAbsInserito',args: args}).then((response) => {
            console.log('RESPONSE EMAIL++++++++++++++++++++++++++++++++')
            console.log(response.data)
            resolve(true)
          })
        })
      })
    }

    createPdf(){
      return new Promise((resolve, reject) => {
        var args = {idAbs: this.row.id, idTemplate:this.teras.evento.template, lingua:'ita',tipoFile:'pdf', isPreview:1}
        this.axios.post(this.axios.apiUrl+'vue/soap',{url:'http://tomcat:8080/j-bvent/services/Ws?wsdl',action:'bamsGeneraAbs',args: args}).then((response) => {
          console.log('RESPONSE CREAPDF++++++++++++++++++++++++++++++++')
          console.log(response.data)
          this.urlPreview = this.teras.urlsite+response.data.data.result.altro.replace("https://bvent.biomedia.net/", "") 
          resolve(true)
        })//fine preview
      })
    }

    nuovo(){
      return new Promise((resolve, reject) => {
        this.axios.query('doQuery',"DELETE FROM token WHERE  id=→id",{id:this.axios.sessionID}).then(() => {
          super.new().then(() => {
            this.row.browsername = this.teras.browsername
            this.row.browserversion = this.teras.browserversion
            this.teras.minutes = 0
            this.row.browsertime = this.teras.minutes
            this.row.evento = this.teras.evento.id
            if(this.teras.evento.poster==2)
              this.row.poster = 1
            this.lineeguida = false
            this.urlPreview = "#"
            this.teras.affiliazioni = []
            this.teras.autori = []
            resolve(true)
          })
        })
      })
    }

    send(){
      return new Promise((resolve, reject) => {
        this.codice()
        super.save().then((response) =>  {
          this.saveAutori().then((response) =>  {
            this.saveAffiliazioni().then((response) =>  {
              this.emailSend().then((response) =>  {
                this.createPdf().then((response) =>  {
                  this.row.inseritoil = moment().format('YYYY-MM-DD HH:mm:00');
                  this.save().then((data) => {
                    this.inviato = true
                    this.nuovo().then(() => {
                      resolve(true)
                    })
                  })
                })
              })
            })
          })
        })
      })
    }
    codice(){
      if(this.row.codice=='')
          this.row.codice = (parseInt(this.teras.evento.bvent)*100000)+parseInt(this.row.id)
    }
    sendnoemail(){
      return new Promise((resolve, reject) => {
        this.row.step=1
        this.codice()
        super.save().then((response) =>  {
          this.saveAutori().then((response) =>  {
            this.saveAffiliazioni().then((response) =>  {
              this.createPdf().then((response) =>  {
                this.save().then((data) => {
                  this.inviato = true
                  this.nuovo().then(() => {
                    resolve(true)
                  })  
                })
              })
            })
          })
        })
      })
    }


    preview(){
      return new Promise((resolve, reject) => {
        super.save().then((response) =>  {
          this.row.token = this.aes.encode(this.row.id)
          super.save()
          this.axios.query('doQuery',"REPLACE INTO token VALUES (→id,←abstract)",{id:this.axios.sessionID,abstract:this.row.id})
          this.saveAutori().then((response) =>  {
            this.saveAffiliazioni().then((response) =>  {
              this.createPdf().then((response) =>  {
                 resolve(true)
              })
            })
          })
        })
      })
/*
this.$abs.save().then(function (data) {
        
        parent.axios.query('doQuery','DELETE FROM autore WHERE abstract=→abstract AND evento=→evento',{evento:parent.$teras.evento.id,abstract:parent.$abs.row.id}).then(function (data) {
          for ( const autore of JSON.parse(JSON.stringify(parent.$teras.autori))){
          autore.primo = (autore.id == parent.$abs.row.pa) ? 1 : 0
          delete autore.id
          autore.abstract = parent.$abs.row.id
          autore.evento = parent.$abs.row.evento
          console.log(typeof autore.affiliazione)
          if(typeof autore.affiliazione == 'object')
            autore.affiliazione = autore.affiliazione.join()
          autore.numero = num
          if(autore.primo==1)
            parent.$abs.row.pa = autore.numero
          num++        
          autori.push(autore)
          }
          console.log(autori)
          parent.axios.insertRows(autori,'autore').then(function (data) {
            parent.axios.query('fetchAll','SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:parent.$teras.evento.id,abstract:parent.$abs.row.id},parent.$teras,'autori')
            parent.axios.query('fetchOne','SELECT id FROM autore WHERE numero=→numero AND abstract=→abstract ',{numero:parent.$abs.row.pa,abstract:parent.$abs.row.id},parent.$abs.row,'pa').then(function (data) {
              parent.$abs.save()
            }) //fine update pa

            parent.axios.query('doQuery','DELETE FROM affiliazione WHERE abstract=→abstract AND evento=→evento',{evento:parent.$teras.evento.id,abstract:parent.$abs.row.id}).then(function (data) {
              var affiliazioni = []
              var num = 0;
              for ( const affiliazione of JSON.parse(JSON.stringify(parent.$teras.affiliazioni))){
              delete affiliazione.id
              affiliazione.abstract = parent.$abs.row.id
              affiliazione.evento = parent.$abs.row.evento
              affiliazione.numero = num
              num++        
              affiliazioni.push(affiliazione)
              }
              console.log(affiliazioni)
              parent.axios.insertRows(affiliazioni,'affiliazione').then(function (data) {
                parent.axios.query('fetchAll','SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:parent.$teras.evento.id,abstract:parent.$abs.row.id},parent.$teras,'affiliazioni')          

                var args = {idAbs: parent.$abs.row.id, idTemplate:parent.$teras.evento.template, lingua:'ita',tipoFile:'pdf', isPreview:1}
                parent.axios.post(parent.axios.apiUrl+'vue/soap',{url:'http://tomcat:8080/j-bvent/services/Ws?wsdl',action:'bamsGeneraAbs',args: args}).then(function (response) {
                  console.log('RESPONSE++++++++++++++++++++++++++++++++')
                  console.log(response.data)

                  parent.urlPreview = parent.$teras.urlsite+response.data.data.result.altro.replace("https://bvent.biomedia.net/", "") 
                  parent.previewReady=true
                  parent.$notify.success({
                    title: 'Preview riuscita',
                    message: "Complimenti ora può visionare il suo abstract...Ecco il link "+parent.urlPreview
                  })
                  parent.$teras.preview=true

                })//fine preview
                

              }) //fine insert affiliazioni
            }) //fine affiliazioni


          }) //fine insert autori
        }) //fine autori

            
          
      

      }) //fine save abs

*/
    }
}

export default new abs


// WEBPACK FOOTER //
// ./src/abs.js